// cleanUrl.js
export function cleanUrl(rawUrl) {
    if (!rawUrl) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = rawUrl;
    return txt.value;
  }
  